import { Container, Grid } from "@mui/material"; 
import React from "react";
import { P, SectionHeading, SectionWrapper } from "../../../styles";
import Accordian from "./Accordian";

import styled from "@emotion/styled"; 
const Socials = styled.div`
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const Sociallinks = styled.a`
  cursor: pointer;
  margin-left: 10px;
`;
const SocialImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 30px;
`;
const accData = [
  [
    "What differentiates RRC from other chains?",
    "RRC will not only prove to be a faster, cheaper, and more efficient Ethereum fork, but is also destined to promote the meme community by creating meme tokens.",
  ],
  [
    " How is the ‘Sacrifice Phase’ different from a Presale?",
    "In a Presale, the tokens can be withdrawn at any time whereas in a ‘Sacrifice Phase’, the tokens are locked for a certain period of time.",
  ],
  [
    "What would be the upcoming announcements that the community should look forward to?",
    "As a starter, we will reach out to a humongous no. of investors in order to make the future of RRC certain.",
    "Also, we will be launching a bridge in the near future so that the Dollar Inu holders can transfer their tokens from Ethereum to the RRC, as it allows faster and cheaper transactions.",
  ],
];

const index = () => {
  return (
    <div style={{ backgroundColor: "#000" }}>
      <SectionWrapper
        pb="10px"
        bgColor="#000"
        id="faq"
        // data-aos="fade-zoom-in"
        // data-aos-easing="ease-in"
        // data-aos-delay="500"
        // data-aos-offset="0"
      >
        <Container maxWidth="xl">
          <SectionHeading mb="0px">F.A.Q&apos;s</SectionHeading>

          <P>
            Want to ask about something else? Head over to our Telegram and ask
            away!
          </P>
          <Grid xs={12} m="20px" />
          <Grid xs={12}>
            <Accordian accContent={accData} />
          </Grid>

          <Socials>
            <P>Follow us:</P>
            <Sociallinks href="#">
              <SocialImage
                src="/images/twitter.png" 
              />
            </Sociallinks>
            <Sociallinks href="#">
              <SocialImage
                src="/images/telegram.png" 
              />
            </Sociallinks>
          </Socials>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
